// Ported from monorepo/src/components/corpus/vocabulary-analysis.tsx —
// known vs unknown word breakdown, the gauge restyled as the catalog card's
// ruled meter.
import type { ReadingCandidate } from "@bindery/shared/corpus/selection";

interface VocabularyAnalysisProps {
  candidate: ReadingCandidate;
}

export function VocabularyAnalysis({ candidate }: VocabularyAnalysisProps) {
  const { knownWordCount, unknownWordCount, knownPercent } = candidate;
  const totalDisplayed = knownWordCount + unknownWordCount;

  return (
    <div className="space-y-2">
      <div className="flex items-baseline justify-between">
        <span className="catalog-label">Vocabulary match</span>
        <span className="font-mono text-sm font-medium tabular-nums">
          {knownPercent}%
        </span>
      </div>

      <div className="bg-muted h-1.5 w-full overflow-hidden rounded-full">
        <div
          className="bg-primary h-full rounded-full transition-all"
          style={{ width: `${Math.min(100, knownPercent)}%` }}
          aria-label={`${knownPercent}% known`}
        />
      </div>

      <div className="text-muted-foreground flex justify-between font-mono text-xs tabular-nums">
        <span>{knownWordCount.toLocaleString()} known</span>
        <span>{unknownWordCount.toLocaleString()} unknown</span>
      </div>

      {totalDisplayed > 0 && totalDisplayed !== candidate.totalWordCount && (
        <p className="text-muted-foreground/70 text-xs">
          {candidate.totalWordCount.toLocaleString()} total words
        </p>
      )}
    </div>
  );
}
